import { ServiceAppError } from 'state/service/appTs/serviceErrors';
import {
  ServiceClientAction,
  ServiceCoreLocalAction,
  ServiceWebsocketAction,
} from '/state/service/appTs/types';
import { ServiceStateStrict } from 'state/service/app';
import defaultAppState from 'defaultAppState';
import serviceClient from './client';
import serviceCore from './core';
import serviceWebsocket from './websocket';

// https://www.typescriptlang.org/docs/handbook/advanced-types.html#using-type-predicates
function isServiceCoreAction(action: BaseTockAction): action is ServiceCoreLocalAction {
  return action.serviceActionType === 'CORE';
}
function isServiceClientAction(action: BaseTockAction): action is ServiceClientAction {
  return action.serviceActionType === 'CLIENT';
}
function isServiceWebsocketAction(action: BaseTockAction): action is ServiceWebsocketAction {
  return action.serviceActionType === 'WEBSOCKET';
}

/**
 * Used in devlopment as we migrate Elm over to TypeScript.
 *
 * Run the following command to run tests and generate coverage on the fly:
 * pnpm test_vitest_coverage test/state/service/ --watch
 */
export default function appTs(
  state: ServiceStateStrict = defaultAppState,
  action: BaseTockAction
): ServiceStateStrict {
  if (isServiceCoreAction(action)) {
    try {
      return serviceCore(state, action);
    } catch (e) {
      if (e instanceof ServiceAppError) {
        return {
          ...state,
          error: e.displayMessage,
        };
      } else {
        throw e;
      }
    }
  } else if (isServiceClientAction(action)) {
    return serviceClient(state, action);
  } else if (isServiceWebsocketAction(action)) {
    return serviceWebsocket(state, action);
  }
  // istanbul ignore next
  return state;
}
